import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-redux-i18n";
import EmptyListingPage from "assets/js/components/EmptyListingPage";
import { Spinner } from "cakemail-ui-components/lib/react";

export function FetchingBrandRepo() {
	return (
		<div className="brandRepoSetup">
			<div>
				<h2>
					<Translate value="app-brand-brand-repo-intro-linking-title" />
				</h2>
				<div className="spinnerContainer">
					<Spinner radius={70} strokeWidth={2} spinnerSpeed={1} />
				</div>
			</div>
		</div>
	);
}

export default FetchingBrandRepo;
